import _ from "lodash";
import React from "react";
import { Html } from "@react-three/drei";
import { Collapse, FormControl, MenuItem, Select, makeStyles } from "@material-ui/core";
import { FiberManualRecord } from "@material-ui/icons";
import { useDispatch, useSelector } from "react-redux";
import { addKeyphrase, removeKeyphrase } from "../epics/canvasEpics";
import { colors } from "../lib/constants";
import TaxonomyData from "../taxonomyData.json";

const useStyles = makeStyles((theme) => ({
  container: {
    userSelect: "none"
  },
  card: {
    display: "flex",
    width: "fit-content",
    height: "fit-content",
    backgroundColor: theme.palette.common.white,
    padding: "5px",
    borderRadius: 500,
    borderTopLeftRadius: 0,
    alignItems: "center",
    boxShadow: "rgb(213, 213, 213) 5px 5px 9px, rgb(255, 255, 255) -5px -5px 9px"
  },
  text: {
    whiteSpace: "nowrap",
    margin: "5px 15px 5px 5px"
  },
  heading: {
    fontWeight: 500,
    paddingRight: 10
  },
  circle: {
    marginRight: 5
  },
  cardSelect: {
    fontSize: "1rem"
  }
}));

export default function Card(props) {
  const { text, position, hover, groupName, color, taxon } = props;
  const classes = useStyles();
  const dispatch = useDispatch();
  const groups = useSelector((state) => state.group, _.isEqual);
  const checkedCardStepOne = useSelector((state) => state.checkedCardStepOne, _.isEqual);
  const checkedCardStepTwo = useSelector((state) => state.checkedCardStepTwo, _.isEqual);
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [cardHover, setCardHover] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState("noGroup");
  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    if (event.target.value === "noGroup") {
      dispatch(removeKeyphrase(text, groups, checkedCardStepOne + " " + checkedCardStepTwo));
    } else if (selectedValue !== "noGroup") {
      dispatch(removeKeyphrase(text, groups, checkedCardStepOne + " " + checkedCardStepTwo));
      dispatch(
        addKeyphrase(
          text,
          position,
          groups[checkedCardStepOne + " " + checkedCardStepTwo][event.target.value],
          event.target.value,
          checkedCardStepOne + " " + checkedCardStepTwo
        )
      );
    } else {
      dispatch(
        addKeyphrase(
          text,
          position,
          groups[checkedCardStepOne + " " + checkedCardStepTwo][event.target.value],
          event.target.value,
          checkedCardStepOne + " " + checkedCardStepTwo
        )
      );
    }
    setCardHover(false);
  };
  return (
    <Html className={classes.container}>
      <Collapse in={hover || cardHover}>
        <div
          className={classes.card}
          onPointerEnter={() => setCardHover(true)}
          onPointerLeave={() => setCardHover(false)}
        >
          <FiberManualRecord style={{ color: taxon === true ? color : colors[selectedValue] }} />
          <div className={classes.text}>
            <table>
              <tbody>
                <tr>
                  <td className={classes.heading}>{taxon === true ? "Taxon: " : "Schlüsselwort: "}</td>
                  <td>{text}</td>
                </tr>
                <tr>
                  {[
                    <td className={classes.heading}>Taxonomie-Gruppe:</td>,
                    taxon === true ? (
                      <td>{groupName}</td>
                    ) : (
                      <td>
                        <FormControl>
                          <Select
                            value={selectedValue}
                            onChange={handleChange}
                            onOpen={() => setMenuOpen(true)}
                            onClose={() => setMenuOpen(false)}
                            color="secondary"
                            className={classes.cardSelect}
                          >
                            <MenuItem value="noGroup">Keine</MenuItem>
                            {_.map(TaxonomyData, (ignore, key) => (
                              <MenuItem value={key}>
                                {menuOpen === true && (
                                  <FiberManualRecord className={classes.circle} style={{ color: colors[key] }} />
                                )}
                                {key}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </td>
                    )
                  ]}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </Collapse>
    </Html>
  );
}
